<div class="qrcodeImage" style="display: flex; flex: 1;">
  <img [src]="qrCodeImgSrc" alt="QR Code">
</div>